<template>
  <div id="app">
    <!-- <router-view :key="$route.fullPath" /> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import index from './pages/index/index.vue'
  export default {
    name: 'App',
    components: {
      'index': index,
    },
    metaInfo: {
      title: '用户中心',
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue